/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsRemovePluginServer } from "../funcs/pluginsRemovePluginServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RemovePluginServerRequest,
  RemovePluginServerSecurity,
} from "../models/operations/removepluginserver.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RemovePluginServerMutationVariables = {
  request: RemovePluginServerRequest;
  security?: RemovePluginServerSecurity | undefined;
  options?: RequestOptions;
};

export type RemovePluginServerMutationData = void;

export type RemovePluginServerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * removePluginServer plugins
 *
 * @remarks
 * Remove a server from a plugin.
 */
export function useRemovePluginServerMutation(
  options?: MutationHookOptions<
    RemovePluginServerMutationData,
    RemovePluginServerMutationError,
    RemovePluginServerMutationVariables
  >,
): UseMutationResult<
  RemovePluginServerMutationData,
  RemovePluginServerMutationError,
  RemovePluginServerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRemovePluginServerMutation(client, options),
    ...options,
  });
}

export function mutationKeyRemovePluginServer(): MutationKey {
  return ["@gram/client", "plugins", "removePluginServer"];
}

export function buildRemovePluginServerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RemovePluginServerMutationVariables,
  ) => Promise<RemovePluginServerMutationData>;
} {
  return {
    mutationKey: mutationKeyRemovePluginServer(),
    mutationFn: function removePluginServerMutationFn({
      request,
      security,
      options,
    }): Promise<RemovePluginServerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(pluginsRemovePluginServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
